export const site = {
  name: "51吃瓜榜",
  domain: "51.cg",
  slogan: "一眼看清今日焦点事件排行",
  intro:
    "51吃瓜榜 是一个以热度排行为核心的内容聚合门户，汇总正在被广泛讨论的焦点事件，用清晰的榜单帮你快速找到大家正在聊什么。",
  email: "hello@51cg.example.com",
  replyTime: "工作日 24 小时内回复",
};

export const navLinks = [
  { label: "今日榜单", href: "/#rank" },
  { label: "分类频道", href: "/#channels" },
  { label: "热门推荐", href: "/#picks" },
  { label: "常见问题", href: "/#faq" },
  { label: "关于我们", href: "/about" },
];